<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>流失客户</h2>
        <p>
          集中查看流失客户，支持按原因筛选、重新激活、重新放回公海池，并保留常用流失原因标签。
        </p>
      </div>
      <div class="crm-actions">
        <el-tag size="small" type="warning">前端演示</el-tag>
      </div>
    </div>

    <div class="reason-tags">
      <el-tag
        v-for="item in reasons"
        :key="item"
        size="small"
        :type="activeReason === item ? 'danger' : 'info'"
        @click.native="activeReason = activeReason === item ? '' : item"
      >
        {{ item }}
      </el-tag>
    </div>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>流失客户列表</span>
        <el-tag size="mini" type="danger"
          >{{ filteredCustomers.length }} 条</el-tag
        >
      </div>
      <el-table :data="filteredCustomers" stripe border>
        <el-table-column
          prop="name"
          label="客户姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" min-width="160">
          <template slot-scope="scope">
            <crm-phone-field :phone="scope.row.phone" status="pending" />
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="lostReason"
          label="流失原因"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ownerName"
          label="归属员工"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="lastFollowTime"
          label="最近跟进时间"
          min-width="140"
        ></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="reactivate(scope.row)"
              >重新激活</el-button
            >
            <el-button type="text" @click="moveToPublic(scope.row)"
              >转入公海</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {
  createOperationLog,
  CRM_OPTIONS,
  loadCrmState,
  saveCrmState,
} from "./mock";
import CrmPhoneField from "./PhoneField.vue";

function formatNow() {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
}

export default {
  name: "CrmLostCustomers",
  components: { CrmPhoneField },
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      reasons: CRM_OPTIONS.lostReasons,
      activeReason: "",
    };
  },
  computed: {
    ownerName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    filteredCustomers() {
      return (this.state.customers || []).filter((item) => {
        if (item.mainStatus !== "已流失") return false;
        if (this.activeReason && item.lostReason !== this.activeReason)
          return false;
        return true;
      });
    },
  },
  methods: {
    persistState() {
      saveCrmState(this.state);
      this.state = loadCrmState(this.ownerName);
    },
    reactivate(customer) {
      const target = (this.state.customers || []).find(
        (item) => item.id === customer.id
      );
      if (!target) return;
      target.mainStatus = "跟进中";
      target.subStatus = "已接通";
      target.intentionLevel = "B中意向";
      target.lostReason = "";
      target.timeline = target.timeline || [];
      target.timeline.unshift({
        time: formatNow(),
        type: "客户恢复",
        title: "重新激活",
        desc: "从流失客户重新激活回正常跟进",
        operator: this.ownerName,
      });
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          "重新激活",
          target.name,
          "流失客户重新激活",
          "成功",
          ""
        )
      );
      this.persistState();
      this.$message.success("客户已重新激活回跟进中");
    },
    moveToPublic(customer) {
      const target = (this.state.customers || []).find(
        (item) => item.id === customer.id
      );
      if (!target) return;
      target.poolType = "公海池";
      target.ownerName = "";
      target.mainStatus = "公海池";
      target.publicReason = "从流失客户转入公海";
      target.publicAt = formatNow();
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          "转公海",
          target.name,
          "从流失客户转入公海",
          "成功",
          ""
        )
      );
      this.persistState();
      this.$message.success("客户已转入公海池");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.reason-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
